<template>
  <AdminBackground v-if="perangkapMinyak && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PERANGKAP MINYAK.png"
        alt="UMUM"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>


    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>
      <h2>PERANGKAP LEMAK, MINYAK, GRIS (FOGT)</h2>
      <div class="fogt">
        <div class="fogt-container">
          <h3>BILANGAN PREMIS MAKANAN YANG MEMPUNYAI PERANGKAP MINYAK</h3>
          <img
            src="@/assets/fogt/makanan.png"
            alt="First Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_premis_makanan_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_premis_makanan_swasta) }}</span></p>
            </div>
          </div>
        </div>

        <div class="fogt-container">
          <h3>BILANGAN PERANGKAP MINYAK JENIS INDIVIDU</h3>
          <img
            src="@/assets/fogt/individu.png"
            alt="Second Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_individu_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_individu_swasta) }}</span></p>
            </div>
          </div>
        </div>

        <div class="fogt-container">
          <h3>BILANGAN PERANGKAP MINYAK JENIS KOMUNAL</h3>
          <img
            src="@/assets/fogt/komunal.png"
            alt="Third Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_komunal_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_komunal_swasta) }}</span></p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>


    <PrimaryModule />
    <KejuruteraanKesihatanMenu />  
  </Adminbackground>
</template>


<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const perangkapMinyak = ref({
  perangkapMinyak: {
    // eslint-disable-next-line camelcase
    bilangan_premis_makanan_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_premis_makanan_swasta: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_individu_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_individu_swasta: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_komunal_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_komunal_swasta: 0,
  },

})

const responseData = ref(null)

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-kesihatan-umum/perangkap-minyak?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    // Populate states dropdown while excluding "Modified Pbt" and null values
    // states.value = ["Semua Negeri"] // Reset with default option
    // if (response.states && typeof response.states === 'object') {
    //   states.value.push(...Object.values(response.states))
    // } else {
    //   console.warn("Expected response.states to be an object, but received:", response.states)
    // }
    
states.value = ["Semua Negeri"] // Reset with default option
const stateList = response.data?.kolam_renang?.states
if (stateList && typeof stateList === 'object') {
  states.value.push(...Object.values(stateList))
} else {
  console.warn("Expected states at response.data.kolam_renang.states, but got:", stateList)
}


    councils.value = response.councils
    responseData.value = response

    perangkapMinyak.value = response.data.perangkap_minyak.data

   
    perangkapMinyak.value.perangkapMinyak = {
      // eslint-disable-next-line camelcase
      bilangan_premis_makanan_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_premis_makanan_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_premis_makanan_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_premis_makanan_swasta : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_individu_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_individu_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_individu_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_individu_swasta : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_komunal_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_komunal_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_komunal_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_komunal_swasta : 0,
    }


  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


h3 {
  color: rgb(21,0,105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}


.fogt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
}

.fogt-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
}

.text-overlay-center {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 60%;
  width: 100%;
  transform: translateY(-50%);
  padding: 0 20px;
  text-align: center;
}

.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.text-center p {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin: 0;
  color: #150069;
}

.number {
  color: #a80000;
  font-size: 28px;
  margin-top: 5px;
}

.swasta-text {
  margin-left: 400px;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
    max-width: 100%;
  }

  .pbt-image, .line-under-image {
    width: 70%;
  }

  h2, h3 {
    font-size: 1.2rem;
  }

  /* Center layout on smaller screens */
  .text-overlay-center {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 80px;
  }

  .text-center p, .number {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2, h3 {
    font-size: 1rem;
  }

  .text-center p, .number {
    font-size: 1rem;
  }
}
</style>
